module.exports = " <div class=cov-progress :style=\"{\n  'width': progress.percent+'%',\n  'height': progress.options.height,\n  'background-color': progress.options.canSuccess? progress.options.color : progress.options.failedColor,\n  'opacity': progress.options.show ? 1 : 0\n}\" _v-79894762=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-79894762!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-progressbar.vue
 ** module id = 8
 ** module chunks = 1
 **/